// Pointage par mission (2026-10-18, audit concurrents) : le salarié appuie sur « Commencer » puis « Terminer »,
// le serveur horodate déjà les deux (started_at, completed_at). On en tire le temps réellement passé, comparé
// à la durée prévue au planning — sans rien ressaisir.
export const formatMinutes = (m: number): string => {
    const total = Math.max(0, Math.round(m));
    if (total < 60) return total + ' min';
    const h = Math.floor(total / 60);
    const r = total % 60;
    return h + ' h' + (r ? ' ' + String(r).padStart(2, '0') : '');
};

/** Minutes entre « Commencer » et « Terminer », ou null si l'une des deux heures manque ou est incohérente. */
export const minutesPasseesSurMission = (startedAt?: string | null, completedAt?: string | null): number | null => {
    if (!startedAt || !completedAt) return null;
    const debut = new Date(startedAt).getTime();
    const fin = new Date(completedAt).getTime();
    if (!Number.isFinite(debut) || !Number.isFinite(fin) || fin < debut) return null;
    return (fin - debut) / 60000;
};

/** Phrase prête à afficher : « Temps passé : 1 h 25 (prévu 1 h, +25 min) ». Vide si le pointage manque. */
export const phraseTempsPasse = (startedAt?: string | null, completedAt?: string | null, prevuMinutes?: number | null): string => {
    const reel = minutesPasseesSurMission(startedAt, completedAt);
    if (reel == null) return '';
    const prevu = Number(prevuMinutes) || 0;
    if (prevu <= 0) return 'Temps passé : ' + formatMinutes(reel);
    const ecart = Math.round(reel - prevu);
    const suite = Math.abs(ecart) < 5 ? 'conforme au prévu' : (ecart > 0 ? '+' : '−') + formatMinutes(Math.abs(ecart));
    return 'Temps passé : ' + formatMinutes(reel) + ' (prévu ' + formatMinutes(prevu) + ', ' + suite + ')';
};
